module.exports = __webpack_public_path__ + "img/tab-edited.106d339a.svg";